import { BuyerProfile, UpdateBuyerProfileRequest } from '../types';
import { USE_MOCK_PROFILE } from '../constants/buyer-portal';
import { profileMock } from '../mocks/profileMock';
import { clinicHttp } from './http';
import { ENDPOINTS } from './endpoints';

export type ProfileService = {
  me: () => Promise<BuyerProfile>;
  update: (patch: UpdateBuyerProfileRequest) => Promise<BuyerProfile>;
};

const realProfileService: ProfileService = {
  me: async () =>
    (await clinicHttp.get<BuyerProfile>(ENDPOINTS.BUYER.PROFILE)).data,
  update: async (patch) =>
    (await clinicHttp.put<BuyerProfile>(ENDPOINTS.BUYER.PROFILE, patch)).data,
};

export const profileService: ProfileService = USE_MOCK_PROFILE
  ? profileMock
  : realProfileService;
